import React, { useEffect, useState } from 'react';
import { Collapse, Checkbox } from 'antd';
import { getPermissions } from "../../../core/data/redux/rolePermissionsSlice";
import { useDispatch, useSelector } from "react-redux";

const { Panel } = Collapse;

interface Permission {
  id: number;
  name: string;
}

interface PermissionsAccordionProps {
  role_id: number;
  handleSelect: (checkedPermissions: number[]) => void;
}

export default function PermissionsAccordion(props: PermissionsAccordionProps) {
  const [permissionData, setPermissionData] = useState<Record<string, Permission[]>>({});
  const [checkedPermissions, setCheckedPermissions] = useState<number[]>([]);

  const dispatch = useDispatch();
  const roleState = useSelector((state: any) => state.roleState);

  // Fetch permissions on mount
  useEffect(() => {
    dispatch(getPermissions({ role_id: props.role_id }));
  }, [dispatch, props.role_id]);

  // When permissions arrive, update permissionData and checkedPermissions
  useEffect(() => {
    if (roleState.loading === "fulfilled" && roleState.action === "get-permission") {
      const result = roleState?.data?.data || {};
      setPermissionData(result);

      // Pre-check all permissions on load
      const allPermissionIds: number[] = [];
      Object.values(result).forEach((permissions:any) => {
        permissions.forEach((perm:any) => {
            if(perm?.role_permission)
                allPermissionIds.push(perm.id);
        });
      });
      setCheckedPermissions(allPermissionIds);
    }
  }, [roleState]);

  // Notify parent when checkedPermissions changes
  useEffect(() => {
    props.handleSelect(checkedPermissions);
  }, [checkedPermissions, props]);

  // Handle individual checkbox toggle
  const handleCheckboxChange = (id: number, checked: boolean) => {
    setCheckedPermissions((prev) =>
      checked ? [...prev, id] : prev.filter((pid) => pid !== id)
    );
  };

  return (
    <Collapse accordion>
      {Object.entries(permissionData).map(([groupName, permissions]) => (
        <Panel header={groupName} key={groupName}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {permissions.map((perm) => (
              <Checkbox
                key={perm.id}
                checked={checkedPermissions.includes(perm.id)}
                onChange={(e) => handleCheckboxChange(perm.id, e.target.checked)}
              >
                {perm.name}
              </Checkbox>
            ))}
          </div>
        </Panel>
      ))}
    </Collapse>
  );
}
